import { IDataState, emptyRequestStatus, createSuccessState } from 'app/store/app/app.models';
import { InfoPostMenuItems } from "@gms/reporting-api/model/infoPostMenuItems";
import { InfoPostDetails, Posting } from '@gms/reporting-api';
import { PostingFilterModel } from "app/store/posting/posting-response.model";
import { ITariffUploadResponse } from './posting.actions';

export interface PostingState {
  postings: IDataState<InfoPostDetails>;
  postingDetails: IDataState<Posting>;
  createdNewRecord: IDataState<any>;
  menuItemList: IDataState<InfoPostMenuItems>;
  isLoading?: boolean;
  error?: any;
  deletePosting: IDataState<boolean>;
  filterData: PostingFilterModel;
  tariffUploadValidation: IDataState<ITariffUploadResponse>;
  downloadPostingDocument: { loading: boolean; httpError: Error; infopostTrackID: number };
}

export const initialPostingFilter: PostingFilterModel = {
  filterData: {},
  istriggerSearchApi: true
}

export const initialPostingState: PostingState = {
  postings: {
    data: {},
    requestStatus: { ...emptyRequestStatus },
  },
  postingDetails: {
    data: { tspId: null },
    requestStatus: { ...emptyRequestStatus },
  },
  menuItemList: {
    data: {},
    requestStatus: { ...emptyRequestStatus },
  },
  createdNewRecord: {
    data: {},
    requestStatus: { ...emptyRequestStatus },
  },
  deletePosting: {
    data: false,
    requestStatus: { ...emptyRequestStatus },
  },
  filterData: initialPostingFilter,
  tariffUploadValidation: createSuccessState(null),
  downloadPostingDocument: {
    httpError: null,
    infopostTrackID: null,
    loading: false
  }
}
